const adminReseller = {
  resellerProgram: 'Програма реселерів',
  customersComeFrom: 'Клієнти надходять з:',
  suppliers: 'Постачальники:',
  installsSoldMonthly: 'Кількість проданих установок щомісяця:',
  channels: 'Канали:',
  services: 'Послуги:',
};

export default adminReseller;
